import { create } from "zustand";
import { PitangoMarketCommon } from "pitango-market-common";

import DTO = PitangoMarketCommon.DTO;

export type AuthStatus = "checking" | "authenticated" | "anonymous";

interface AuthState {
    user: DTO.UserView | null;
    status: AuthStatus;
    sessionVersion: number;
    setUser: (user: DTO.UserView | null) => void;
    signOutLocal: () => void;
}

/**
 * Cross-page session state. Hydrated once on app load by `authApi.authenticate()`
 * (see `app-providers`) and updated by sign-in/sign-out flows.
 */
export const useAuthStore = create<AuthState>(set => ({
    user: null,
    status: "checking",
    sessionVersion: 0,
    setUser: user => set(state => ({ user, status: user ? "authenticated" : "anonymous", sessionVersion: state.sessionVersion + 1 })),
    signOutLocal: () => set(state => ({ user: null, status: "anonymous", sessionVersion: state.sessionVersion + 1 }))
}));
